"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PreviewBlockPopover;

var _element = require("@wordpress/element");

var _i18n = require("@wordpress/i18n");

var _components = require("@wordpress/components");

var _blockPreview = _interopRequireDefault(require("../block-preview"));

/**
 * WordPress dependencies
 */

/**
 * Internal dependencies
 */
function PreviewBlockPopover(_ref) {
  var blocks = _ref.blocks;
  return (0, _element.createElement)("div", {
    className: "block-editor-block-switcher__popover__preview__parent"
  }, (0, _element.createElement)("div", {
    className: "block-editor-block-switcher__popover__preview__container"
  }, (0, _element.createElement)(_components.Popover, {
    className: "block-editor-block-switcher__preview__popover",
    position: "bottom right",
    focusOnMount: false
  }, (0, _element.createElement)("div", {
    className: "block-editor-block-switcher__preview"
  }, (0, _element.createElement)("div", {
    className: "block-editor-block-switcher__preview-title"
  }, (0, _i18n.__)('Preview')), (0, _element.createElement)(_blockPreview.default, {
    viewportWidth: 500,
    blocks: blocks
  })))));
}
//# sourceMappingURL=preview-block-popover.js.map